import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UrlSerializer } from '@angular/router';
import { AuthModule } from '@auth0/auth0-angular';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ToastrModule } from 'ngx-toastr';
import { Guards } from 'src/app/library/guards/guards.export';
import { httpInterceptorProviders } from 'src/app/library/interceptors/interceptors.export';
import { LowerCaseUrlSerializer } from 'src/app/library/utilities/strings/UrlSerializer';
import { CoreModule } from 'src/app/modules/core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutComponent } from './app.layout';
import { RootLoaderComponent } from './library/components/root-loader/root-loader.component';
import {
    EnvironmentService,
    InitializeEnvironmentFactory
} from './library/services/core/environment.service';
import { NavigationService } from './library/services/general/navigation.service';
import { SharedModule } from './modules/core/shared.module';
import { SideNavModule } from './modules/side-nav/sidenav.module';
import { SystemVersionModule } from './modules/system-version/system-version.module';
import { UtilityModule } from './modules/utility/utility.module';

@NgModule({
    declarations: [AppComponent, AppLayoutComponent, RootLoaderComponent],
    imports: [
        UtilityModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        LayoutModule,
        UtilityModule,
        ScrollingModule,
        OverlayModule,
        AuthModule.forRoot(),
        SideNavModule,
        FilterPipeModule,
        MatProgressSpinnerModule,
        ToastrModule.forRoot({
            preventDuplicates: true,
            positionClass: 'toast-top-right'
        }),
        SystemVersionModule
    ],
    providers: [
        ...Guards,
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        },
        {
            provide: APP_INITIALIZER,
            useFactory: InitializeEnvironmentFactory,
            deps: [EnvironmentService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (navService: NavigationService) => () =>
                navService.ngOnInit(),
            deps: [NavigationService],
            multi: true
        },
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: { useUtc: true }
        },
        ...httpInterceptorProviders
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
